// import React, { useState } from "react";
// import ClgfacilitiesDegree from "./ClgfacilitiesDegree";
// import LabDtlsDegree from "./LabDtlsDegree";
// import BuildBlockdtls from "./BuildBlockdtls";
// import Instructional from "./Instructional";
// import SoclandDtls from "./SoclandDtls";
// import OtherInfraDtls from "./OtherInfraDtls";


// const DegreeInfraTabs = () => {
//   const [activeTab, setActiveTab] = useState(1);
//   // const GetServiceCompleted = useCallback(() => {
//   //   CommonAxiosGet(`${config.url.FAC_URL}getServicesDone`).then((res) => {
//   //     if (res?.data?.scode === "01") {
//   //       setApiData(res.data.count?.[0] || {});
//   //     }

//   // }, []);

//   const tabs = [

//     {
//       id: 1,
//       label: "Land Allocation",
//       component: <SoclandDtls />
//     },
//     {
//       id: 2,
//       label: "Building Block Details",
//       component: <BuildBlockdtls />
//     },
//     {
//       id: 3,
//       label: "Instructional Area",
//       component: <Instructional />
//     },
//     {
//       id: 4,
//       label: "College Facilities and Biometrics",
//       component: <ClgfacilitiesDegree />
//     },


//     {
//       id: 5,
//       label: "Other Infrastructure Details",
//       component: <OtherInfraDtls />
//     },

//     {
//       id: 6,
//       label: "Lab Area Details",
//       component: <LabDtlsDegree />
//     },






//   ];

//   return (

//     <div className="infra-tabs">

//       <div className="infra-tabs__header">
//         {tabs.map((tab) => (
//           <button
//             key={tab.id}
//             className={`infra-tabs__tab ${activeTab === tab.id ? "infra-tabs__tab--active" : ""
//               }`}
//             onClick={() => setActiveTab(tab.id)}
//           >
//             {tab.label}
//           </button>
//         ))}
//       </div>

//       <div className="infra-tabs__content">
//         <div key={activeTab} className="infra-tabs__panel">
//           {tabs.find((t) => t.id === activeTab).component}
//         </div>
//       </div>

//     </div>

//   );
// };

// export default DegreeInfraTabs;


import React, { useState } from "react";
import ClgfacilitiesDegree from "./ClgfacilitiesDegree";
import LabDtlsDegree from "./LabDtlsDegree";
import BuildBlockdtls from "./BuildBlockdtls";
import Instructional from "./Instructional";
import SoclandDtls from "./SoclandDtls";
import OtherInfraDtls from "./OtherInfraDtls";
import { FaHardHat } from "react-icons/fa";
const DegreeInfraTabs = ({ statusList = [], paymentDone = false, onStepSaved }) => {
  const [activeTab, setActiveTab] = useState(1);

  const statusMap = {
    soc_land_details: statusList.find((s) => s.name === "Land Allocation")?.done ?? false,
    buildblock_details: statusList.find((s) => s.name === "Building Block Details")?.done ?? false,
    instructional_area: statusList.find((s) => s.name === "Instructional Area")?.done ?? false,
    college_facilities: statusList.find((s) => s.name === "College Facilities")?.done ?? false,
    other_infra: statusList.find((s) => s.name === "Other Infrastructure")?.done ?? false,
    lab_area_details: statusList.find((s) => s.name === "Lab Area Details")?.done ?? false,
  };

  /* Called by child after successful save → jump to next tab immediately */
  // const goNextTab = () => setActiveTab((p) => Math.min(p + 1, 6));
  const goNextTab = () => {
    onStepSaved?.();           // ← re-fetches API in parent immediately
    setActiveTab((p) => Math.min(p + 1, 6));
  };

  // const tabs = [
  //   { id: 1, label: "Land Allocation", apiKey: "soc_land_details", component: <SoclandDtls goNext={goNextTab} paymentDone={paymentDone} /> },
  //   { id: 2, label: "Building Block Details", apiKey: "buildblock_details", component: <BuildBlockdtls goNext={goNextTab} paymentDone={paymentDone} /> },
  //   { id: 3, label: "Instructional Area", apiKey: "instructional_area", component: <Instructional goNext={goNextTab} paymentDone={paymentDone} /> },
  //   { id: 4, label: "College Facilities & Biometrics", apiKey: "college_facilities", component: <ClgfacilitiesDegree goNext={goNextTab} paymentDone={paymentDone} /> },
  //   { id: 5, label: "Other Infrastructure Details", apiKey: "other_infra", component: <OtherInfraDtls goNext={goNextTab} paymentDone={paymentDone} /> },
  //   { id: 6, label: "Lab Area Details", apiKey: "lab_area_details", component: <LabDtlsDegree goNext={goNextTab} paymentDone={paymentDone} /> },
  // ];

  const tabs = [
    {
      id: 1, label: "Land Allocation", apiKey: "soc_land_details",
      component: <SoclandDtls goNext={goNextTab} paymentDone={paymentDone} />
    },
    {
      id: 2, label: "Building Block Details", apiKey: "buildblock_details",
      component: <BuildBlockdtls goNext={goNextTab} paymentDone={paymentDone} />
    },
    {
      id: 3, label: "Instructional Area", apiKey: "instructional_area",
      component: <Instructional goNext={goNextTab} paymentDone={paymentDone} />
    },
    {
      id: 4, label: "College Facilities & Biometrics", apiKey: "college_facilities",
      component: <ClgfacilitiesDegree goNext={goNextTab} paymentDone={paymentDone} />
    },
    {
      id: 5, label: "Other Infrastructure Details", apiKey: "other_infra",
      component: <OtherInfraDtls goNext={goNextTab} paymentDone={paymentDone} />
    },
    {
      id: 6, label: "Lab Area Details", apiKey: "lab_area_details",
      component: <LabDtlsDegree goNext={goNextTab} paymentDone={paymentDone} />
    },
  ];

  const doneCount = tabs.filter((t) => statusMap[t.apiKey]).length;
  const pct = Math.round((doneCount / tabs.length) * 100);

  return (
    <div style={{ fontFamily: "inherit" }}>

      {/* ── Progress bar only — no label/text ── */}
      {/* <div style={{ marginBottom: "1rem" }}>
        <div style={{
          height: 5,
          background: "var(--color-background-secondary)",
          borderRadius: 99,
          overflow: "hidden",
          border: "0.5px solid var(--color-border-tertiary)",
        }}>
          <div style={{
            height: "100%",
            borderRadius: 99,
            background: pct === 100 ? "#1D9E75" : "#2563eb",
            width: `${pct}%`,
            transition: "width 0.4s ease",
          }} />
        </div>
      </div> */}

      {/* ── Progress bar ── */}
      <div style={{
        background: "var(--color-background-primary)",
        border: "0.5px solid var(--color-border-tertiary)",
        borderRadius: "var(--border-radius-lg)",
        padding: "14px 18px",
        marginBottom: "1rem",
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

          {/* Label */}
          <span style={{
            fontSize: 13, fontWeight: 500,
            color: "var(--color-text-primary)",
            display: "flex", alignItems: "center", gap: 7,
          }}>
            <FaHardHat style={{
              fontSize: 14,
              color: pct === 100 ? "#10B981" : pct > 33 ? "#3B82F6" : "#F59E0B",
            }} />
            Infrastructure completion
          </span>

          {/* Badge */}
          <span style={{
            fontSize: 12, fontWeight: 500,
            padding: "3px 13px",
            borderRadius: 99,
            background: pct === 100 ? "#ECFDF5" : pct > 33 ? "#EFF6FF" : pct === 0 ? "#F3F4F6" : "#FEF9EE",
            color: pct === 100 ? "#065F46" : pct > 33 ? "#1D4ED8" : pct === 0 ? "#6B7280" : "#92400E",
            border: `1px solid ${pct === 100 ? "#A7F3D0" : pct > 33 ? "#BFDBFE" : pct === 0 ? "#D1D5DB" : "#FDE68A"}`,
            transition: "all 0.4s ease",
          }}>
            {doneCount} / {tabs.length} completed
          </span>
        </div>

        {/* Track */}
        <div style={{
          height: 8,
          marginTop: 10,
          borderRadius: 99,
          overflow: "hidden",
          background: pct === 100 ? "#D1FAE5" : pct > 33 ? "#DBEAFE" : pct === 0 ? "#F3F4F6" : "#FEF3C7",
          transition: "background 0.4s ease",
        }}>
          {/* Fill */}
          <div style={{
            height: "100%",
            borderRadius: 99,
            width: `${pct}%`,
            background: pct === 100 ? "#10B981" : pct > 33 ? "#3B82F6" : "#F59E0B",
            transition: "width 0.6s cubic-bezier(0.4, 0, 0.2, 1), background 0.4s ease",
            position: "relative",
            overflow: "hidden",
          }}>
            {/* Shimmer */}
            {pct > 0 && pct < 100 && (
              <div style={{
                position: "absolute",
                top: 0, left: "-100%",
                width: "60%", height: "100%",
                background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.35), transparent)",
                animation: "shimmer 1.8s infinite",
              }} />
            )}
          </div>
        </div>
      </div>

      {/* Shimmer keyframe — add once anywhere in your CSS file */}
      {/* @keyframes shimmer { to { left: 150%; } } */}
      {/* ── Tab header — flex wrap so NO scrollbar ── */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",           /* wrap instead of scroll */
        gap: 0,
        borderBottom: "0.5px solid var(--color-border-tertiary)",
      }}>
        {tabs.map((tab) => {
          const isDone = statusMap[tab.apiKey] === true;
          const isActive = activeTab === tab.id;

          /* isDone always wins even when active */
          const statusText = isDone ? "Completed" : isActive ? "In Progress" : "Pending";
          const dotColor = isDone ? "#1D9E75" : isActive ? "#2563eb" : "var(--color-border-secondary)";
          const labelColor = isDone ? "#0F6E56" : isActive ? "#2563eb" : "var(--color-text-secondary)";
          const subColor = isDone ? "#1D9E75" : isActive ? "#93b4f0" : "var(--color-text-tertiary)";

          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 3,
                padding: "8px 12px",
                border: "none",
                borderBottom: isActive ? "2px solid #2563eb" : "2px solid transparent",
                marginBottom: "-0.5px",
                background: isActive
                  ? "var(--color-background-secondary)"
                  : "transparent",
                cursor: "pointer",
                borderRadius: "6px 6px 0 0",
                transition: "background 0.15s",
                flex: "1 1 auto",      /* each tab takes equal share — no overflow */
                minWidth: 0,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <span style={{
                  width: 7, height: 7,
                  borderRadius: "50%",
                  background: dotColor,
                  flexShrink: 0,
                  transition: "background 0.2s",
                }} />
                <span style={{
                  fontSize: 12,
                  fontWeight: isActive ? 500 : 400,
                  color: labelColor,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}>
                  {tab.label}
                </span>
              </div>
              <span style={{ fontSize: 10, color: subColor, paddingLeft: 12 }}>
                {statusText}
              </span>
            </button>
          );
        })}
      </div>

      {/* ── Tab content ── */}
      <div style={{
        background: "var(--color-background-primary)",
        border: "0.5px solid var(--color-border-tertiary)",
        borderTop: "none",
        borderRadius: "0 0 var(--border-radius-lg) var(--border-radius-lg)",
        padding: "1.25rem",
      }}>
        <div key={activeTab}>
          {tabs.find((t) => t.id === activeTab)?.component}
        </div>
      </div>

    </div>
  );
};

export default DegreeInfraTabs;







// import React, { useState } from "react";
// import ClgfacilitiesDegree from "./ClgfacilitiesDegree";
// import LabDtlsDegree from "./LabDtlsDegree";
// import BuildBlockdtls from "./BuildBlockdtls";
// import Instructional from "./Instructional";
// import SoclandDtls from "./SoclandDtls";
// import OtherInfraDtls from "./OtherInfraDtls";

// const DegreeInfraTabs = ({ statusList = [], paymentDone = false }) => {
//   const [activeTab, setActiveTab] = useState(1);

//   const statusMap = {
//     soc_land_details:   statusList.find((s) => s.name === "Land Allocation")?.done        ?? false,
//     buildblock_details: statusList.find((s) => s.name === "Building Block Details")?.done ?? false,
//     instructional_area: statusList.find((s) => s.name === "Instructional Area")?.done     ?? false,
//     college_facilities: statusList.find((s) => s.name === "College Facilities")?.done     ?? false,
//     other_infra:        statusList.find((s) => s.name === "Other Infrastructure")?.done   ?? false,
//     lab_area_details:   statusList.find((s) => s.name === "Lab Area Details")?.done       ?? false,
//   };

//   const goNextTab = () => setActiveTab((p) => Math.min(p + 1, 6));

//   const tabs = [
//     { id: 1, label: "Land Allocation",                apiKey: "soc_land_details",   component: <SoclandDtls         goNext={goNextTab} paymentDone={paymentDone} /> },
//     { id: 2, label: "Building Block Details",          apiKey: "buildblock_details", component: <BuildBlockdtls      goNext={goNextTab} paymentDone={paymentDone} /> },
//     { id: 3, label: "Instructional Area",              apiKey: "instructional_area", component: <Instructional       goNext={goNextTab} paymentDone={paymentDone} /> },
//     { id: 4, label: "College Facilities & Biometrics", apiKey: "college_facilities", component: <ClgfacilitiesDegree goNext={goNextTab} paymentDone={paymentDone} /> },
//     { id: 5, label: "Other Infrastructure Details",    apiKey: "other_infra",        component: <OtherInfraDtls      goNext={goNextTab} paymentDone={paymentDone} /> },
//     { id: 6, label: "Lab Area Details",                apiKey: "lab_area_details",   component: <LabDtlsDegree       goNext={goNextTab} paymentDone={paymentDone} /> },
//   ];

//   const doneCount = tabs.filter((t) => statusMap[t.apiKey]).length;
//   const pct = Math.round((doneCount / tabs.length) * 100);

//   return (
//     <div style={{ fontFamily: "inherit" }}>

//       {/* ── Slim progress bar ── */}
//       <div style={{ marginBottom: "1.25rem" }}>
//         <div style={{
//           height: 4,
//           background: "var(--color-background-secondary)",
//           borderRadius: 99,
//           overflow: "hidden",
//           border: "0.5px solid var(--color-border-tertiary)",
//         }}>
//           <div style={{
//             height: "100%",
//             borderRadius: 99,
//             background: pct === 100 ? "#1D9E75" : "#2563eb",
//             width: `${pct}%`,
//             transition: "width 0.4s ease",
//           }} />
//         </div>
//       </div>

//       {/* ── Tab cards ── */}
//       <div style={{
//         display: "grid",
//         gridTemplateColumns: "repeat(6, 1fr)",
//         gap: 8,
//         marginBottom: "1.25rem",
//       }}>
//         {tabs.map((tab) => {
//           const isDone   = statusMap[tab.apiKey] === true;
//           const isActive = activeTab === tab.id;

//           /* colour tokens */
//           const borderColor = isDone
//             ? "#1D9E75"
//             : isActive
//             ? "#2563eb"
//             : "var(--color-border-tertiary)";

//           const bgColor = isDone
//             ? "#f0fbf7"
//             : isActive
//             ? "#eff4ff"
//             : "var(--color-background-primary)";

//           const badgeBg = isDone
//             ? "#E1F5EE"
//             : isActive
//             ? "#dbeafe"
//             : "var(--color-background-secondary)";

//           const badgeColor = isDone
//             ? "#0F6E56"
//             : isActive
//             ? "#1d4ed8"
//             : "var(--color-text-tertiary)";

//           const labelColor = isDone
//             ? "#0F6E56"
//             : isActive
//             ? "#1d4ed8"
//             : "var(--color-text-primary)";

//           const statusText = isDone ? "Completed" : isActive ? "In Progress" : "Pending";

//           /* icon: checkmark svg / spinner dot / grey dot */
//           const Icon = () => {
//             if (isDone) return (
//               <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
//                 <circle cx="7" cy="7" r="7" fill="#1D9E75" />
//                 <polyline points="3.5,7 6,9.5 10.5,4.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//               </svg>
//             );
//             if (isActive) return (
//               <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
//                 <circle cx="7" cy="7" r="7" fill="#2563eb" />
//                 <circle cx="7" cy="7" r="2.5" fill="#fff" />
//               </svg>
//             );
//             return (
//               <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
//                 <circle cx="7" cy="7" r="6.5" stroke="var(--color-border-secondary)" strokeWidth="1" fill="none" />
//                 <circle cx="7" cy="7" r="2.5" fill="var(--color-border-secondary)" />
//               </svg>
//             );
//           };

//           return (
//             <button
//               key={tab.id}
//               onClick={() => setActiveTab(tab.id)}
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "flex-start",
//                 gap: 8,
//                 padding: "12px 10px",
//                 background: bgColor,
//                 border: `1.5px solid ${borderColor}`,
//                 borderRadius: 10,
//                 cursor: "pointer",
//                 textAlign: "left",
//                 transition: "all 0.15s ease",
//                 boxSizing: "border-box",
//                 width: "100%",
//               }}
//             >
//               {/* icon row */}
//               <Icon />

//               {/* label */}
//               <span style={{
//                 fontSize: 12,
//                 fontWeight: isActive || isDone ? 600 : 400,
//                 color: labelColor,
//                 lineHeight: 1.35,
//                 wordBreak: "break-word",
//               }}>
//                 {tab.label}
//               </span>

//               {/* status badge */}
//               <span style={{
//                 display: "inline-block",
//                 fontSize: 10,
//                 fontWeight: 500,
//                 padding: "2px 8px",
//                 borderRadius: 99,
//                 background: badgeBg,
//                 color: badgeColor,
//                 border: `0.5px solid ${borderColor}`,
//                 marginTop: "auto",
//                 whiteSpace: "nowrap",
//               }}>
//                 {statusText}
//               </span>
//             </button>
//           );
//         })}
//       </div>

//       {/* ── Tab content ── */}
//       <div style={{
//         background: "var(--color-background-primary)",
//         border: "0.5px solid var(--color-border-tertiary)",
//         borderRadius: "var(--border-radius-lg)",
//         padding: "1.25rem",
//       }}>
//         <div key={activeTab}>
//           {tabs.find((t) => t.id === activeTab)?.component}
//         </div>
//       </div>

//     </div>
//   );
// };

// export default DegreeInfraTabs;